<template>
  <div style="clear: both;">
    <template v-if="readonly && modelValue">
      <v-text-field density="comfortable"
        :label="approvedStartDateLabel" variant="underlined" :model-value="$filters.DateFilter(modelValue)" readonly dense></v-text-field>
    </template>

    <template v-if="!readonly">
      <v-menu
        v-model="formSettings.approvedStartDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ props: menu }">
          <v-text-field
            :model-value="$filters.DateFilter(formattedDate)"
            :label="approvedStartDateLabel"
            prepend-icon="mdi-calendar-outline"
            readonly
            variant="underlined"
            v-bind="menu"
            density="comfortable"
            :rules="rules.approvedStartDateRules"
          ></v-text-field>
        </template>
        <template v-if="!readonly">
          <v-date-picker
            :model-value="selectedDate"            
            no-title
            hide-header
            :min="minDateComputed"
            :max="maxDateComputed365"
            :readonly="readonly"
            v-on:update:model-value="updateValue"
          ></v-date-picker>
        </template>
      </v-menu>
    </template>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import dateMixins from '@/mixins/dateMixins'
import moment from 'moment'
export default {
  emits: ['update:modelValue'],
  name: 'ApprovedStartDateField',
  mixins: [dateMixins],
  data() {
    let self = this
    return {
      formSettings: {
        approvedStartDateMenu: false
      },
      picker: null,
      rules: {
        approvedStartDateRules: [
          v => !v || self.dateEqualOrIsBefore(v, new Date(new Date().toDateString())) || this.$t('Date_Not_In_Past')
        ]
      }
    }
  },
  props: {
    modelValue: {
      type: String
    },
    roles: {
      type: Array,
      default: null
    },
    fromModal: {
      type: Boolean,
      default: false
    },
    forceReadonly: {
      type: Boolean,
      default: false
    },
    moc: {
      type: Object
    }
  },
  methods: {
    dateEqualOrIsBefore(fromDate, toDate) {
      if (((this.moc.ownerDecision || {}).decision || {}).key === 'approved') {
        return true
      }

      // what if we are in unathorized extend and in submitted status...
      // if there is history there was an approval since teh owners decision was reset
      if (((this.moc.ownerDecision || {}).history || []).length > 0) {
        return true
      }

      if (fromDate) {
        return new Date(fromDate) >= new Date(toDate)
      }
    },
    updateValue: function(value) {
      this.formSettings.approvedStartDateMenu = false
      let now = moment()
      let time = now.hour() + ':' + now.minute() + ':' + now.second()
      let dateString = value.getFullYear() + '-' + this.getTimeLeftPad(value.getMonth() + 1)  + '-' + this.getTimeLeftPad(value.getDate())
      console.log(`approved start date field moment(dateString + ' ' + time).format() ${moment(dateString + ' ' + time).format()}`)
      this.$emit('update:modelValue', moment(dateString + ' ' + time).format())
    },
    getTimeLeftPad: function(number){
      // console.log(`number ${number}`)
      if(number.length < 2){
        return '0' + number
      }
      return number
    }    
  },
  computed: {
    readonly: function() {
      if (this.forceReadonly) {
        return true
      }
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          return true
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          return true
        case FormStatus.properties[FormStatus.SUBMITTED].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return true
          }
          return false
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          return true
        case FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value:
          if (this.roles.includes(Roles.properties[Roles.OWNER].value) && this.fromModal) {
            return false
          }
          return true
        case FormStatus.properties[FormStatus.OWNERAPPROVEDDEFERREDSTARTDATE].value:
          if (this.roles.includes(Roles.properties[Roles.OWNER].value)) {
            return false
          }
          return true
        default:
          return true
      }
    },
    approvedStartDateLabel: function() {
      return this.$t('Owner_Approved_Start_Date')
    },
    selectedDate: function() {
      if (!this.modelValue) return null
      // return this.formatDate(this.modelValue)
      return new Date(this.modelValue)
    }
  }
}
</script>

<style scoped></style>
